import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { RowDetailState } from '@devexpress/dx-react-grid';
import isEqual from 'lodash/isEqual';

class RowDetailStateContainer extends Component {
	shouldComponentUpdate = ({
		expandedRowIds,
	}) => {
		const lastProps = this.props;

		return (
			!isEqual(expandedRowIds, lastProps.expandedRowIds)
		);
	}

	render() {
		const { expandedRowIds } = this.props;

		return (
			<RowDetailState
				expandedRowIds={expandedRowIds}
			/>
		);
	}
}

const mapStateToProps = ({
	jobs: {
		expandedRowIds,
	},
}) => ({
	expandedRowIds,
});

RowDetailStateContainer.propTypes = {
	expandedRowIds : PropTypes.array,
};

RowDetailStateContainer.defaultProps = {
	expandedRowIds : [],
};

export default connect(mapStateToProps)(RowDetailStateContainer);
